import { CommonBody } from "types/General";
import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const investmentApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllInvestment: builder.query<CommonResponse & { data: any }, {}>({
      query: () => ({
        url: `${END_POINTS.investment}`,
        method: "GET",
      }),
    }),

    getInvestmentPlanById: builder.query<
      CommonResponse & { data: any },
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getInvestmentPlanById}/${id}`,
        method: "GET",
      }),
    }),

    addInvestmentPlan: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.investment,
        method: "POST",
        body,
      }),
    }),

    getInvestmentUserList: builder.query<
      CommonResponse & { data: any },
      { page: number; search: string; status: number }
    >({
      query: ({ page, search, status }) => ({
        url: `${END_POINTS.investmentList}?page=${page}&search=${search}&status=${status}`,
        method: "GET",
      }),
    }),

    changeInvestmentListStatus: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.investmentListStatus}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    updateInvestmentPlan: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateInvestmentPlan}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    getAgreementList: builder.query<
      CommonResponse & { data: any },
      { page: number; search: string }
    >({
      query: ({ page, search }) => ({
        url: `${END_POINTS.agreementList}?page=${page}&search=${search}`,
        method: "GET",
      }),
    }),

    addAgreement: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addAgreement,
        method: "POST",
        body,
      }),
    }),

    deleteAgreement: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteAgreement}/${id}`,
        method: "DELETE",
      }),
    }),

    updateAgreement: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateAgreement}/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetAllInvestmentQuery,
  useAddInvestmentPlanMutation,
  useLazyGetInvestmentUserListQuery,
  useChangeInvestmentListStatusMutation,
  useUpdateInvestmentPlanMutation,
  useLazyGetInvestmentPlanByIdQuery,
  useLazyGetAgreementListQuery,
  useAddAgreementMutation,
  useLazyDeleteAgreementQuery,
  useUpdateAgreementMutation,
} = investmentApi;
